import { Fragment, useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@redux/hooks';
import { fetchUserAutoList, getIsLoadedListAuto, getUserAutoList, getIsErrorListAuto } from '@entities/Auto';
import { Badge, SkeletonLoading } from '@app/shared';
import { IconChevronRight } from '@koleso-icons';
import { useRouter } from 'next/router';
import { useWindowSizing } from '@hooks/useSizeWindow';
import { WrapperErrorLkShort } from '@app/shared';

import classNames from 'classnames';

import styles from './shortInfoAutoUser.module.scss';

export const ShortInfoAutoUser = ({ className }: { className?: string }) => {
  const router = useRouter();
  const dispatch = useAppDispatch();
  const isMobile = useWindowSizing(990);
  const listAuto = useAppSelector(getUserAutoList);
  const firstAuto = listAuto?.length && listAuto[0];
  const isLoadedAuto = useAppSelector(getIsLoadedListAuto);
  const isError = useAppSelector(getIsErrorListAuto);

  useEffect(() => {
    if (!isLoadedAuto && !listAuto?.length) {
      dispatch(fetchUserAutoList());
    }
  }, []);

  const handlerRoute = useCallback(async () => {
    await router.push('/personal/auto/');
  }, []);

  const handlerRouteMobile = useCallback(async () => {
    isMobile && (await router.push('/personal/auto/'));
  }, [isMobile]);

  if (isError) {
    return (
      <Fragment>
        <div className={classNames(styles.Wrapper, className)} onClick={handlerRouteMobile}>
          <div className={styles.Container}>
            <div className={styles.Title} onClick={handlerRoute}>
              Мои автомобили
              <IconChevronRight width={16} height={16} />
            </div>
          </div>
          <WrapperErrorLkShort error={isError} className={styles.ErrorMessage} />
        </div>
      </Fragment>
    );
  }

  if (!isLoadedAuto) {
    return <SkeletonLoading className={styles.WrapperSkeleton} width={'100%'} height={'100%'} />;
  }

  if (!listAuto?.length && isLoadedAuto) {
    return (
      <div className={classNames(styles.Wrapper, className)} onClick={handlerRouteMobile}>
        <div className={styles.Container}>
          <div className={styles.Title} onClick={handlerRoute}>
            Мои автомобили
            <IconChevronRight width={16} height={16} />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={classNames(styles.Wrapper, className)} onClick={handlerRouteMobile}>
      <div className={styles.Container}>
        <div className={styles.Title} onClick={handlerRoute}>
          {firstAuto.carMark}
          <IconChevronRight width={16} height={16} />
        </div>
        <div className={styles.subTitle}>{firstAuto.gtd}</div>
      </div>
      {listAuto?.length > 1 && (
        <Badge className={styles.Badge} onClick={handlerRoute}>
          +{listAuto?.length - 1}
          <span>авто</span>
          <IconChevronRight width={16} height={16} />
        </Badge>
      )}
    </div>
  );
};
